/* ============================================================
   OS9 BROWSER PAGE — SquichaVista (AltaVista spoof / Portfolio)
   Register: window.OS9BrowserPages['altavista']

   Results are edited in the Shopify theme editor:
     OS9 Desktop section → Add block → "SquichaVista Result"

   Each result supports: title, client, year, category, tags,
   description, icon, thumbnail, and up to 20 gallery images.
   Clicking a result opens a lightbox within the browser window.
   Images are CSS-protected (no right-click, no drag, no select).
   squiche.com
   ============================================================ */

(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════════════
     FALLBACK RESULTS — used only when theme editor has no blocks.
     Delete these once you've added real entries in Shopify.
  ═══════════════════════════════════════════════════════════ */
  var DEFAULTS = [
    {
      category: 'web',
      title:    'Squiche OS — Retro Mac Desktop Experience',
      client:   'Squiche Design Labs',
      year:     '2024',
      url:      'https:squiche.com',
      domain:   'www.squiche.com',
      desc:     'A fully interactive Mac OS 8/9-style desktop built in vanilla JS and CSS. Features draggable windows, a working Internet Browser, Photoshoop\u2122, and a custom desktop environment running entirely in the browser on Shopify.',
      tags:     ['design', 'javascript', 'shopify', 'retro'],
      thumb:    '', icon: '', images: [], protected: true
    },
    {
      category: 'personal',
      title:    'Add your work in the Shopify theme editor',
      client:   'You',
      year:     '2025',
      url:      '#',
      domain:   'www.squiche.com',
      desc:     'Go to the Shopify theme editor \u2192 OS9 Desktop section \u2192 Add block \u2192 SquichaVista Result to add your portfolio entries here.',
      tags:     ['portfolio', 'squiche'],
      thumb:    '', icon: '', images: [], protected: true
    }
  ];

  /* ═══════════════════════════════════════════════════════════
     CATEGORY CONFIG
  ═══════════════════════════════════════════════════════════ */
  var CATS = {
    web:      { label: 'Web & Interactive', color: '#cc0000', badge: 'WEB'      },
    client:   { label: 'Client Work',       color: '#006699', badge: 'CLIENT'   },
    art:      { label: 'Art & Prints',      color: '#006600', badge: 'ART'      },
    viral:    { label: 'Viral / Internet',  color: '#990099', badge: 'VIRAL'    },
    personal: { label: 'Personal Work',     color: '#cc6600', badge: 'PERSONAL' }
  };

  /* ═══════════════════════════════════════════════════════════
     STATE
  ═══════════════════════════════════════════════════════════ */
  var _el            = null;
  var _query         = '';
  var _activeCategory = 'all';
  var _lightboxOpen  = false;
  var _carIdx        = 0;

  /* ═══════════════════════════════════════════════════════════
     CSS
  ═══════════════════════════════════════════════════════════ */
  var CSS = [
    /* ── base ── */
    '#sqv{font-family:Arial,Helvetica,sans-serif;font-size:13px;background:#fff;color:#000;min-height:100%;box-sizing:border-box;-webkit-user-select:none;user-select:none;}',

    /* ── header ── */
    '#sqv-header{width:100%;display:block;border-bottom:2px solid #cc9900;background:#fff;}',
    '#sqv-header img{width:100%;max-width:100%;display:block;}',

    /* ── yellow search zone ── */
    '#sqv-search-zone{background:linear-gradient(to bottom,#ffdd00 0%,#ffcc00 60%,#ffbb00 100%);border-bottom:3px solid #cc9900;padding:8px 12px 10px;}',
    '#sqv-search-row{display:flex;align-items:center;gap:0;max-width:700px;}',
    '#sqv-q{flex:1;height:24px;border:2px inset #999;padding:0 6px;font-size:13px;font-family:Arial,Helvetica,sans-serif;background:#fff;outline:none;-webkit-user-select:text;user-select:text;}',
    '#sqv-q:focus{border-color:#000080;}',
    '#sqv-go{height:24px;padding:0 12px;background:linear-gradient(to bottom,#e8e8e8,#c8c8c8);border:2px outset #ccc;font-size:12px;font-weight:bold;font-family:Arial,Helvetica,sans-serif;cursor:default;white-space:nowrap;margin-left:4px;}',
    '#sqv-go:active{border-style:inset;}',

    /* ── specialty searches row ── */
    '#sqv-specialty{display:flex;align-items:flex-start;border-top:1px solid #cccccc;border-bottom:2px solid #000066;background:#fff;}',
    '#sqv-spec-label{padding:8px 14px;font-size:13px;font-weight:bold;color:#000066;text-align:right;min-width:100px;max-width:100px;flex-shrink:0;line-height:1.3;padding-top:10px;}',
    '#sqv-spec-links{padding:8px 12px;font-size:12px;line-height:1.9;}',
    /* Each link has the dash appended inside so it stays nowrap with its own text.
       Breaks only happen at the space BETWEEN spans — never before a dash. */
    '.sqv-slink{color:#000080;text-decoration:underline;cursor:default;white-space:nowrap;display:inline;}',
    '.sqv-slink:hover{color:#cc0000;}',
    '.sqv-slink--active{color:#cc0000;font-weight:bold;text-decoration:none;}',

    /* ── count bar ── */
    '#sqv-count{background:#e8e8f0;border-bottom:1px solid #ccc;padding:3px 10px;font-size:11px;color:#444;display:flex;justify-content:space-between;align-items:center;}',

    /* ── sponsor ── */
    '#sqv-sponsor{background:#fffff0;border:1px solid #cccc99;margin:6px 12px;padding:5px 8px;font-size:11px;color:#666;display:flex;align-items:center;gap:8px;}',
    '#sqv-sponsor strong{color:#cc0000;font-size:10px;}',
    '#sqv-sponsor a{color:#000080;}',

    /* ── result list ── */
    '#sqv-list{padding:8px 12px;}',

    /* ── result card ── */
    '.sqv-card{margin-bottom:16px;padding-bottom:14px;border-bottom:1px solid #e8e8e8;display:flex;gap:8px;align-items:flex-start;cursor:default;}',
    '.sqv-card:last-child{border-bottom:none;}',
    '.sqv-card:hover{background:#f8f8ff;}',

    /* icon */
    '.sqv-icon{width:32px;height:32px;min-width:32px;flex-shrink:0;display:flex;align-items:center;justify-content:center;margin-top:2px;}',
    '.sqv-icon img{width:32px;height:32px;object-fit:contain;display:block;image-rendering:-webkit-optimize-contrast;image-rendering:crisp-edges;}',
    '.sqv-icon--empty{width:32px;height:32px;background:#e8e8e8;border:1px solid #ccc;}',

    /* category badge */
    '.sqv-badge{font-size:9px;font-weight:bold;padding:2px 5px;color:#fff;text-transform:uppercase;letter-spacing:0.06em;flex-shrink:0;margin-top:3px;align-self:flex-start;white-space:nowrap;}',

    /* body */
    '.sqv-body{flex:1;min-width:0;}',
    '.sqv-title{font-size:14px;font-weight:bold;color:#000080;text-decoration:underline;display:block;margin-bottom:1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
    '.sqv-card:hover .sqv-title{color:#cc0000;}',
    '.sqv-meta{font-size:10px;color:#888;margin-bottom:2px;}',
    '.sqv-url{font-size:11px;color:#008000;margin-bottom:3px;display:block;}',
    '.sqv-desc{font-size:12px;color:#000;line-height:1.4;margin-bottom:4px;}',
    '.sqv-read-more{color:#000080;text-decoration:underline;cursor:default;font-size:12px;white-space:nowrap;}',
    '.sqv-read-more:hover{color:#cc0000;}',
    '.sqv-tags{display:flex;gap:4px;flex-wrap:wrap;}',
    '.sqv-tag{font-size:9px;font-weight:bold;padding:1px 5px;border:1px solid;text-transform:uppercase;letter-spacing:0.04em;}',

    /* thumbnail */
    '.sqv-thumb{width:60px;height:45px;flex-shrink:0;border:1px solid #ccc;overflow:hidden;display:flex;align-items:center;justify-content:center;}',
    '.sqv-thumb img{width:100%;height:100%;object-fit:cover;display:block;pointer-events:none;}',
    '.sqv-thumb--empty{display:none;}',

    /* ── no results ── */
    '#sqv-empty{padding:20px 12px;font-size:13px;color:#444;display:none;}',
    '#sqv-empty strong{color:#cc0000;}',
    '#sqv-empty a{color:#000080;}',

    /* ── footer ── */
    '#sqv-footer{background:#f0f0f0;border-top:2px solid #cc9900;padding:8px 12px;font-size:10px;color:#666;text-align:center;}',
    '#sqv-footer a{color:#000080;}',

    /* ════════════════════════════════════════════════════════
       LIGHTBOX — fills .os9-browser-content viewport
       Theme-editor colors override these defaults via CSS vars
       set in openLightbox: --sqv-bg, --sqv-text, --sqv-nav-bg.
    ════════════════════════════════════════════════════════ */
    '#sqv-lb{position:absolute;inset:0;background:var(--sqv-bg, #1a1a1a);color:var(--sqv-text, #eeeeee);z-index:400;display:flex;flex-direction:column;overflow:hidden;}',

    /* header bar — uses --sqv-bg (background color) per design intent */
    '#sqv-lb-bar{background:var(--sqv-bg, #2a2a2a);border-bottom:1px solid #444;padding:8px 12px;display:flex;align-items:center;justify-content:space-between;flex-shrink:0;gap:12px;}',
    '#sqv-lb-title{font-family:"Chicago","Charcoal","Monaco",monospace;font-size:13px;font-weight:bold;color:var(--sqv-text, #ffffff);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;flex:1;}',
    '#sqv-lb-meta{font-size:11px;color:var(--sqv-text, #aaaaaa);opacity:0.7;white-space:nowrap;flex-shrink:0;}',
    /* The close box sits on the LEADING edge, at every width — every window on
       this desktop closes from the top-left, so a preview that closed from the
       right would be the one surface breaking the rule. It is also the corner a
       thumb reaches on a phone, and it keeps our control clear of the OS9
       window's own buttons on the right. `order:-1` moves it without reordering
       the markup, so focus order still runs title-then-close. */
    '#sqv-lb-close{background:#c0392b;border:none;color:#fff;font-size:14px;font-weight:bold;width:24px;height:24px;display:flex;align-items:center;justify-content:center;cursor:default;flex-shrink:0;border-radius:2px;font-family:monospace;order:-1;margin-right:10px;}',
    '#sqv-lb-close:hover{background:#e74c3c;}',

    /* body — scrolls vertically. Gallery fills the visible viewport;
       info flows below and is reached by scrolling. */
    /* `scroll` on both axes, matching [id^="os9-page-"]. This panel sits
       inside the browser window and has to read as part of it — with
       overflow-y:auto it drew a bare native-ish bar with no arrows and no
       size box, which is the moment the illusion drops. os9-windows.css names
       #sqv-lb-body alongside the page divs so it inherits the same channels,
       arrows and greyed states, and watchScrollable() is run on it below so
       those states track real overflow. */
    '#sqv-lb-body{flex:1;min-height:0;overflow:scroll;}',

    /* gallery pane — natural height, hugs the image. No forced
       100% of body height (which caused letterboxing top + bottom
       when image aspect didn't match viewport aspect). */
    '#sqv-lb-gallery{display:block;background:var(--sqv-bg, #111111);}',

    /* carousel — track is a horizontal scroll-snap strip. Browser
       handles swipe natively. Track height is set dynamically in JS
       to match the current image so the carousel nav below hugs each
       image regardless of aspect ratio (eliminates the dead space
       that landscape images had when the strip was sized to the
       tallest portrait). transition: height smooths the resize when
       _carIdx changes. */
    '#sqv-carousel{display:block;}',
    '#sqv-carousel-track{display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch;align-items:flex-start;transition:height 0.22s ease-out;}',
    '#sqv-carousel-track::-webkit-scrollbar{display:none;}',
    '#sqv-carousel-nav{display:flex;align-items:center;justify-content:center;gap:18px;padding:7px 12px;background:var(--sqv-nav-bg, #1a1a1a);border-top:1px solid #333;flex-shrink:0;}',
    '#sqv-prev,#sqv-next,#sqv-shuffle,#sqv-fs-btn{background:#333;border:1px solid #555;color:#ccc;width:28px;height:28px;cursor:default;display:flex;align-items:center;justify-content:center;flex-shrink:0;-webkit-user-select:none;user-select:none;}',
    '#sqv-prev,#sqv-next{font-size:12px;font-family:monospace;}',
    '#sqv-shuffle{font-size:15px;margin-left:6px;}',
    '#sqv-fs-btn{font-size:14px;margin-left:6px;}',
    '#sqv-prev:hover,#sqv-next:hover,#sqv-shuffle:hover,#sqv-fs-btn:hover{background:#444;color:#fff;}',
    '#sqv-shuffle.shuffled{color:#7df;border-color:#7df;}',
    '#sqv-car-counter{font-size:11px;color:#666;font-family:Geneva,sans-serif;min-width:44px;text-align:center;}',

    /* Slot — one per image in the carousel strip. flex:0 0 100% so each
       takes the full track width; scroll-snap-align:start makes the
       browser snap to each slot's start edge. */
    '.sqv-img-slot{flex:0 0 100%;width:100%;scroll-snap-align:start;position:relative;}',
    /* Artwork scales to fit the browser window in BOTH directions. It used to
       be width:100% / height:auto, which only respected width — a portrait
       piece then rendered taller than the window and you had to scroll to see
       the whole thing. width:auto + max-width/max-height lets the image shrink
       on whichever axis runs out first, so it always fits and never distorts.
       --sqv-img-max-h is set from JS to the space actually available inside
       the lightbox (see sizeGallery), because the browser window is not the
       viewport — vh units would be wrong here. */
    '.sqv-img-slot img{width:auto;height:auto;max-width:100%;' +
      'max-height:var(--sqv-img-max-h, 420px);margin:0 auto;' +
      'display:block;pointer-events:none;-webkit-user-drag:none;user-drag:none;vertical-align:top;}',
    /* The protection overlay — covers each slot image, eats right-click
       and drag. touch-action: pan-x lets horizontal pan pass through to
       the track scroll, so swipes work. Tap (no movement) still fires
       click which opens fullscreen. */
    /* Scoped under .sqv-img-slot for specificity (0,2,0). Dawn's base.css
       hides empty elements via `div:empty { display:none }` (0,1,1), which
       outranked a bare `.sqv-img-shield` (0,1,0) — and this div IS empty, so
       the shield was never rendered at all.

       Consequences while it was hidden: touch-action:pan-x never applied, so
       a horizontal swipe on the image got claimed by the lightbox body's
       vertical scroll and the carousel wouldn't advance on mobile; the
       right-click/drag protection was absent; and tap-to-fullscreen never
       fired from the shield.

       The ::before below was an attempt to defeat :empty — it can't. :empty
       counts child nodes only and ignores pseudo-elements, so the div stayed
       empty. Specificity is the actual fix; the ::before is kept because it
       guarantees a hit area even before the image loads. */
    '.sqv-img-slot .sqv-img-shield{display:block;position:absolute;inset:0;z-index:1;cursor:zoom-in;'
      /* pan-x AND pan-y: pan-x alone permits horizontal panning but BLOCKS
         vertical, so once this shield became visible it prevented scrolling
         down to the info panel. Allowing both lets the browser pick by
         gesture direction — horizontal drives the carousel, vertical scrolls
         the lightbox — while still suppressing pinch-zoom and double-tap. */
      + 'touch-action:pan-x pan-y;}',
    '.sqv-img-slot .sqv-img-shield::before{content:"";position:absolute;inset:0;}',

    /* no-images placeholder — min-height instead of 100% since the
       gallery is now natural-height (no parent to be 100% of). */
    '#sqv-lb-noimages{display:none;flex-direction:column;align-items:center;justify-content:center;min-height:240px;color:#555;font-size:12px;font-family:Geneva,sans-serif;gap:8px;text-align:center;padding:20px;}',

    /* info pane — flows naturally below the gallery in the scrollable
       body. No max-height / overflow constraints; user scrolls the
       whole body to see the info section. */
    '#sqv-lb-info{display:flex;flex-direction:column;gap:12px;width:100%;box-sizing:border-box;background:var(--sqv-bg, #2a2a2a);border-top:1px solid #444;padding:14px 12px;}',

    /* ════════════════════════════════════════════════════════
       FULLSCREEN IMAGE MODE — covers entire viewport above OS9
       chrome. Preserves image protection (no right-click save,
       no drag, no iOS long-press save sheet). Two-finger pinch
       zoom is allowed via touch-action: pinch-zoom.
    ════════════════════════════════════════════════════════ */
    /* touch-action: none — JS implements custom pinch zoom + swipe on its
       own. The browser must not interpret any touches here as scroll, pan,
       or pinch-zoom of the page. transform-origin center on the img so
       custom scale grows from the middle. */
    '.sqv-fs{position:fixed;inset:0;background:#000;z-index:2147483600;display:flex;align-items:center;justify-content:center;touch-action:none;-webkit-touch-callout:none;overflow:hidden;}',
    '.sqv-fs img{max-width:100vw;max-height:100vh;width:auto;height:auto;display:block;pointer-events:none;-webkit-user-drag:none;user-drag:none;-webkit-touch-callout:none;transform-origin:center center;transition:transform 0.12s ease-out;}',
    '.sqv-fs-shield{position:absolute;inset:0;z-index:1;cursor:default;touch-action:none;-webkit-touch-callout:none;}',
    '.sqv-fs-close{position:absolute;top:14px;left:14px;width:40px;height:40px;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.7);color:#fff;border:1px solid rgba(255,255,255,0.5);font-size:22px;font-family:monospace;cursor:default;z-index:2;border-radius:2px;}',
    '.sqv-fs-close:hover{background:rgba(40,40,40,0.9);}',
    '.sqv-fs-counter{position:absolute;bottom:14px;left:50%;transform:translateX(-50%);background:rgba(0,0,0,0.7);color:#aaa;padding:4px 10px;font-size:11px;font-family:Geneva,sans-serif;border-radius:2px;z-index:2;}',

    /* info sections */
    '.sqv-lb-section{}',
    '.sqv-lb-label{font-size:9px;font-weight:bold;text-transform:uppercase;letter-spacing:0.1em;color:var(--sqv-label, #888888);margin-bottom:4px;}',
    '.sqv-lb-value{font-size:12px;color:var(--sqv-text, #eeeeee);line-height:1.5;font-family:Geneva,"Lucida Sans",sans-serif;}',
    '.sqv-lb-desc{font-size:11px;color:var(--sqv-text, #cccccc);opacity:0.88;line-height:1.6;font-family:Georgia,serif;}',

    /* tag pills in lightbox */
    '.sqv-lb-tags{display:flex;flex-wrap:wrap;gap:4px;}',
    '.sqv-lb-tag{font-size:9px;font-weight:bold;padding:2px 6px;background:#444;color:#ddd;text-transform:uppercase;letter-spacing:0.05em;}',

    /* image counter */
    '#sqv-lb-counter{font-size:10px;color:#666;text-align:center;padding:4px 0;font-family:Geneva,sans-serif;}',

    /* context menu block */
    '#sqv{-webkit-touch-callout:none;}'
  ].join('');

  /* ═══════════════════════════════════════════════════════════
     HELPERS
  ═══════════════════════════════════════════════════════════ */
  function injectCSS() {
    if (document.getElementById('sqv-css')) return;
    var s = document.createElement('style');
    s.id = 'sqv-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function getResults() {
    var cfg = window.OS9Config && window.OS9Config.portfolioItems;
    if (cfg && Array.isArray(cfg) && cfg.length > 0) return cfg;
    return DEFAULTS;
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function filterResults(q, cat) {
    var query = (q || '').toLowerCase().trim();
    return getResults().filter(function(r) {
      if (cat !== 'all' && r.category !== cat) return false;
      if (!query) return true;
      var hay = [r.title, r.client, r.year, r.desc, (r.tags || []).join(' ')].join(' ').toLowerCase();
      return hay.indexOf(query) !== -1;
    });
  }

  /* ═══════════════════════════════════════════════════════════
     LIGHTBOX
  ═══════════════════════════════════════════════════════════ */
  /* Where a result goes when you click it.

     Authored per result in the theme editor as `open_mode`:
       popup  — the image viewer below. The default, and what every result
                did before this existed, so nothing changes unless asked.
       custom — a purpose-built lander (McDondal's, Cockbuster) registered in
                OS9BrowserPages, opened as a real page in its own tab with its
                own address, rather than as a modal over the results.

     A 'custom' result whose page is missing or unregistered falls back to the
     pop-up. Silently doing nothing on click is the one outcome worth ruling
     out — a typo'd page key would otherwise look like a dead result. */
  function openResult(r) {
    var mode = r && r.openMode;
    if (mode && mode !== 'popup') {
      /* The mode IS the page key. It was briefly a separate free-text field
         and that failed silently whenever it was left blank — the setting
         read "Custom" while the click still showed the pop-up, with nothing
         to explain why. One value, chosen from a list, cannot drift. */
      var key = String(mode).trim();
      var registered = window.OS9BrowserPages && window.OS9BrowserPages[key];
      var open = window.OS9Browser && window.OS9Browser.openTab;
      if (registered && open) { open(key); return; }
    }
    openLightbox(r);
  }

  function openLightbox(r) {
    if (!_el) return;
    _lightboxOpen = true;

    var contentEl = _el.closest('.os9-browser-content') || _el;
    if (getComputedStyle(contentEl).position === 'static') contentEl.style.position = 'relative';

    /* Remove existing */
    var old = contentEl.querySelector('#sqv-lb');
    if (old) old.remove();

    var cat   = CATS[r.category] || { label: r.category, color: '#666', badge: '?' };
    var imgs  = Array.isArray(r.images) ? r.images.filter(Boolean) : [];
    var prot  = r.protected !== false; /* default true */
    var meta  = [r.client, r.year].filter(Boolean).join(' \u2014 ');
    var tags  = (r.tags || []).map(function(t) {
      return '<span class="sqv-lb-tag">' + esc(t.trim()) + '</span>';
    }).join('');

    /* Gallery HTML — carousel: one image at a time with prev/next nav */
    _carIdx = 0;
    var galleryHTML = '';
    if (imgs.length === 0) {
      galleryHTML = '<div id="sqv-lb-noimages" style="display:flex;">No images added yet.<br>Upload gallery images in the theme editor.</div>';
    } else {
      var shield = prot ? '<div class="sqv-img-shield" oncontextmenu="return false;" ondragstart="return false;"></div>' : '';
      /* Nav appears whenever we have at least one image — fullscreen button
         is always present, prev/next/counter only when there's more than one. */
      var navHTML = imgs.length >= 1
        ? '<div id="sqv-carousel-nav">' +
            (imgs.length > 1 ? '<button id="sqv-prev">◄</button>' : '') +
            (imgs.length > 1 ? '<span id="sqv-car-counter">1 / ' + imgs.length + '</span>' : '') +
            (imgs.length > 1 ? '<button id="sqv-next">►</button>' : '') +
            '<button id="sqv-fs-btn" title="View fullscreen">⛶</button>' +
          '</div>'
        : '';
      /* Render every image as its own scroll-snap slot. First image is
         eagerly loaded; the rest are loading="lazy" so the browser
         only fetches them as the user scrolls toward each one. */
      var slotsHTML = imgs.map(function (src, i) {
        return '<div class="sqv-img-slot">' +
          '<img src="' + esc(src) + '" alt="' + esc(r.title) + ' — image ' + (i + 1) + '"' +
          ' draggable="false" oncontextmenu="return false;"' +
          (i === 0 ? '' : ' loading="lazy"') + '>' +
          shield +
        '</div>';
      }).join('');
      galleryHTML =
        '<div id="sqv-carousel">' +
          '<div id="sqv-carousel-track">' + slotsHTML + '</div>' +
          navHTML +
        '</div>';
    }

    var lb = document.createElement('div');
    lb.id = 'sqv-lb';
    /* Per-result color overrides from theme editor settings. Empty values
       (Shopify color picker can be cleared to '') fall through to the
       hardcoded defaults in the CSS via the var() fallback syntax. */
    if (r.bgColor)    lb.style.setProperty('--sqv-bg',     r.bgColor);
    if (r.textColor)  lb.style.setProperty('--sqv-text',   r.textColor);
    if (r.navColor)   lb.style.setProperty('--sqv-nav-bg', r.navColor);
    if (r.labelColor) lb.style.setProperty('--sqv-label',  r.labelColor);
    lb.innerHTML =
      '<div id="sqv-lb-bar">' +
        '<div id="sqv-lb-title">' + esc(r.title) + '</div>' +
        (meta ? '<div id="sqv-lb-meta">' + esc(meta) + '</div>' : '') +
        '<div id="sqv-lb-close" title="Close">\u00d7</div>' +
      '</div>' +
      '<div id="sqv-lb-body" class="os9-scroller">' +
        '<div id="sqv-lb-gallery">' + galleryHTML + '</div>' +
        '<div id="sqv-lb-info">' +
          '<div class="sqv-lb-section">' +
            '<div class="sqv-lb-label">Project</div>' +
            '<div class="sqv-lb-value">' + esc(r.title) + '</div>' +
          '</div>' +
          (r.client ? '<div class="sqv-lb-section"><div class="sqv-lb-label">Client</div><div class="sqv-lb-value">' + esc(r.client) + '</div></div>' : '') +
          (r.year   ? '<div class="sqv-lb-section"><div class="sqv-lb-label">Year</div><div class="sqv-lb-value">' + esc(r.year) + '</div></div>' : '') +
          '<div class="sqv-lb-section"><div class="sqv-lb-label">Category</div><div class="sqv-lb-value" style="color:' + cat.color + ';font-weight:bold;">' + esc(cat.label) + '</div></div>' +
          (r.desc   ? '<div class="sqv-lb-section"><div class="sqv-lb-label">About</div><div class="sqv-lb-desc">' + esc(r.desc) + '</div></div>' : '') +
          (tags     ? '<div class="sqv-lb-section"><div class="sqv-lb-label">Tags</div><div class="sqv-lb-tags">' + tags + '</div></div>' : '') +
          (prot     ? '<div class="sqv-lb-section" style="margin-top:auto;padding-top:12px;border-top:1px solid #444;"><div class="sqv-lb-label" style="color:#555;">\u{1f512} Images protected</div></div>' : '') +
        '</div>' +
      '</div>';

    contentEl.appendChild(lb);

    /* Block context menu on the whole lightbox */
    lb.addEventListener('contextmenu', function(e) { e.preventDefault(); });

    /* ── Fit the artwork to the browser window ───────────────────────────
       Measures what's actually left for the image once the title bar and the
       carousel nav have taken their share, and publishes it as
       --sqv-img-max-h for the CSS above. Recomputed whenever the browser
       window is resized or zoomed, so the artwork stays fully visible at any
       window size, desktop or mobile.

       Deliberately measured rather than expressed in vh: this lightbox lives
       inside a draggable OS9 window, so the viewport height is unrelated to
       the space the image actually has. */
    function sizeGallery() {
      var bodyEl = lb.querySelector('#sqv-lb-body');
      var navEl  = lb.querySelector('#sqv-carousel-nav');
      if (!bodyEl) return;
      var navH = navEl ? navEl.offsetHeight : 0;
      /* Leave a little room so the info panel below peeks up and hints that
         there is more to scroll to. */
      var avail = bodyEl.clientHeight - navH - 12;
      lb.style.setProperty('--sqv-img-max-h', Math.max(140, avail) + 'px');
      /* Setting that variable is what makes the artwork — and therefore the
         panel's content — change height, so this is the one place that knows
         the scroll state is now stale. watchScrollable() parks its checker on
         the element for exactly this. */
      if (bodyEl._os9Recheck) bodyEl._os9Recheck();
    }
    sizeGallery();
    requestAnimationFrame(sizeGallery);
    if (window.ResizeObserver) {
      var galleryRO = new ResizeObserver(function () {
        if (!lb.isConnected) { galleryRO.disconnect(); return; }
        sizeGallery();
      });
      galleryRO.observe(contentEl);
    } else {
      window.addEventListener('resize', sizeGallery);
    }

    /* Close button */
    lb.querySelector('#sqv-lb-close').addEventListener('click', closeLightbox);

    /* Same treatment the Finder and the Geocities gallery get.

       Opening a result is a commitment — the visitor has chosen this piece and
       will almost certainly page through it — so warm the whole carousel
       rather than a window of it. These sets are small (13 in the example),
       which is why a fixed slice is right here where it was wrong for a
       97-image gallery. The first image is already on screen; the rest are
       one arrow press away. */
    var warm = window.OS9Windows && window.OS9Windows.warmImages;
    if (warm && imgs.length) warm(imgs.slice(0, 16));

    /* Without this the panel keeps whatever scroll state it was born with,
       and the arrows never grey — the bug that made this scrollbar look
       unlike every other one in the window. */
    var bodyForWatch = lb.querySelector('#sqv-lb-body');
    if (bodyForWatch && window.OS9Windows && window.OS9Windows.watchScrollable) {
      window.OS9Windows.watchScrollable(bodyForWatch);
    }

    /* Carousel — strip + scroll-snap. Browser handles the swipe gesture
       natively (image follows finger, snaps on release). JS keeps
       _carIdx + counter in sync via the scroll event. goTo() programmatic
       navigation just sets scrollLeft and the snap takes over. */
    var track   = lb.querySelector('#sqv-carousel-track');
    var counter = lb.querySelector('#sqv-car-counter');
    function goTo(idx) {
      if (imgs.length < 2 || !track) return;
      var target = ((idx % imgs.length) + imgs.length) % imgs.length;
      track.scrollTo({ left: target * track.clientWidth, behavior: 'smooth' });
    }
    if (track && imgs.length > 1) {
      /* Debounced scroll handler keeps _carIdx aligned with whichever slot
         the strip has snapped to. Doesn't fire goTo (we ARE the scroll). */
      var scrollTimeout = null;
      track.addEventListener('scroll', function () {
        if (scrollTimeout) cancelAnimationFrame(scrollTimeout);
        scrollTimeout = requestAnimationFrame(function () {
          var w = track.clientWidth;
          if (w <= 0) return;
          var newIdx = Math.round(track.scrollLeft / w);
          if (newIdx === _carIdx || newIdx < 0 || newIdx >= imgs.length) return;
          _carIdx = newIdx;
          if (counter) counter.textContent = (_carIdx + 1) + ' / ' + imgs.length;
        });
      }, { passive: true });

      var prevBtn = lb.querySelector('#sqv-prev');
      var nextBtn = lb.querySelector('#sqv-next');
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(_carIdx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(_carIdx + 1); });
    }

    /* Fullscreen button — view current image edge-to-edge with protection
       preserved. Pinch-zoom allowed on mobile via touch-action: pinch-zoom. */
    function openCurrentFullscreen() {
      var currentSrc = imgs[_carIdx];
      if (!currentSrc) return;
      openFullscreen(currentSrc, r.title, imgs, _carIdx);
    }
    var fsBtn = lb.querySelector('#sqv-fs-btn');
    if (fsBtn) fsBtn.addEventListener('click', openCurrentFullscreen);

    /* Tap any slot's image (via its protection shield) → fullscreen.
       The browser's scroll-snap handles drag-to-swipe natively — when
       the user actually drags, no click event fires, so this only
       triggers on real taps. Delegated on the track so it covers
       every slot's shield. Right-click is still blocked by the shield's
       oncontextmenu="return false;" attribute. */
    if (track) {
      track.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.sqv-img-shield')) {
          openCurrentFullscreen();
        }
      });
    }

    /* Escape key closes */
    function onKey(e) { if (e.key === 'Escape') { closeLightbox(); document.removeEventListener('keydown', onKey); } }
    document.addEventListener('keydown', onKey);
  }

  /* ═══════════════════════════════════════════════════════════
     FULLSCREEN IMAGE MODE
     Covers entire viewport above the OS9 chrome at fixed-position
     z-index 2147483600. Preserves image protection:
       • <img draggable="false"> + oncontextmenu="return false;"
       • Sibling .sqv-fs-shield overlay catches iOS long-press
         (which bypasses the image's own contextmenu)
       • -webkit-touch-callout: none disables the long-press save sheet

     Pinch zoom is implemented by us as a transform on the <img>
     element only — we explicitly block all native page zoom (iOS
     gesture* events, Mac wheel+ctrlKey, two-finger touch pinch) so
     a pinch only scales the image, never the OS9 chrome behind.
  ═══════════════════════════════════════════════════════════ */
  function openFullscreen(src, title, imgs, startIdx) {
    var fs = document.createElement('div');
    fs.className = 'sqv-fs';
    var hasMany = Array.isArray(imgs) && imgs.length > 1;
    var idx = startIdx || 0;

    /* Zoom state — applied as transform: scale() on the .sqv-fs-img */
    var currentScale  = 1;
    var pinchStartDist = 0;
    var pinchStartScale = 1;
    var MIN_SCALE = 1, MAX_SCALE = 5;

    fs.innerHTML =
      '<img class="sqv-fs-img" src="' + esc(src) + '" alt="' + esc(title) + '" draggable="false" oncontextmenu="return false;">' +
      '<div class="sqv-fs-shield" oncontextmenu="return false;" ondragstart="return false;"></div>' +
      '<button class="sqv-fs-close" title="Close (Esc)">×</button>' +
      (hasMany ? '<div class="sqv-fs-counter">' + (idx + 1) + ' / ' + imgs.length + '</div>' : '');

    document.body.appendChild(fs);

    /* Block right-click anywhere inside the overlay */
    fs.addEventListener('contextmenu', function (e) { e.preventDefault(); });

    function applyImgScale() {
      var img = fs.querySelector('.sqv-fs-img');
      if (img) img.style.transform = 'scale(' + currentScale + ')';
    }

    function setImage(newIdx) {
      idx = (newIdx + imgs.length) % imgs.length;
      currentScale = 1;
      applyImgScale();
      var img = fs.querySelector('.sqv-fs-img');
      var ctr = fs.querySelector('.sqv-fs-counter');
      if (img) img.src = imgs[idx];
      if (ctr) ctr.textContent = (idx + 1) + ' / ' + imgs.length;
    }

    function close() {
      if (fs.parentNode) fs.parentNode.removeChild(fs);
      document.removeEventListener('keydown', onFsKey);
    }
    function onFsKey(e) {
      if (e.key === 'Escape') close();
      else if (hasMany && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
        setImage(idx + (e.key === 'ArrowRight' ? 1 : -1));
      }
    }
    fs.querySelector('.sqv-fs-close').addEventListener('click', close);
    document.addEventListener('keydown', onFsKey);

    /* ── Custom pinch zoom — image only, never the page ────────────
       Three input paths, all preventDefault'd so the browser's native
       zoom never fires (which would zoom the entire viewport):
         1. iOS Safari gesture* events (use e.scale directly)
         2. Other touch devices: two-finger touchstart/touchmove,
            compute scale from finger distance
         3. Mac trackpad: wheel + ctrlKey, use deltaY for delta scale
       ────────────────────────────────────────────────────────────── */
    function getTouchDistance(touches) {
      var dx = touches[0].clientX - touches[1].clientX;
      var dy = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    fs.addEventListener('gesturestart',  function (e) {
      e.preventDefault();
      pinchStartScale = currentScale;
    }, { passive: false });
    fs.addEventListener('gesturechange', function (e) {
      e.preventDefault();
      currentScale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, pinchStartScale * e.scale));
      applyImgScale();
    }, { passive: false });
    fs.addEventListener('gestureend',    function (e) { e.preventDefault(); }, { passive: false });

    fs.addEventListener('wheel', function (e) {
      if (!e.ctrlKey) return; /* trackpad pinch is reported as wheel + ctrlKey */
      e.preventDefault();
      e.stopPropagation(); /* don't let the global guard double-handle */
      currentScale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, currentScale - e.deltaY * 0.01));
      applyImgScale();
    }, { passive: false });

    /* Swipe navigation (single finger) + pinch zoom (two fingers) share
       the same touchstart/move/end listeners. Single touch = potential
       swipe. Two touches = active pinch — also blocks swipe accounting. */
    var swipeStart = null;
    fs.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        pinchStartDist = getTouchDistance(e.touches);
        pinchStartScale = currentScale;
        swipeStart = null; /* cancel any in-progress swipe */
      } else if (e.touches.length === 1 && hasMany) {
        swipeStart = { x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now() };
      } else {
        swipeStart = null;
      }
    }, { passive: false });
    fs.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && pinchStartDist > 0) {
        e.preventDefault();
        var newDist = getTouchDistance(e.touches);
        currentScale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, pinchStartScale * newDist / pinchStartDist));
        applyImgScale();
      }
    }, { passive: false });
    fs.addEventListener('touchend', function (e) {
      if (e.touches.length < 2) pinchStartDist = 0;
      if (!swipeStart || !hasMany) return;
      var end = e.changedTouches[0];
      var dx = end.clientX - swipeStart.x;
      var dy = end.clientY - swipeStart.y;
      var dt = Date.now() - swipeStart.t;
      swipeStart = null;
      if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.2 || dt > 500) return;
      setImage(idx + (dx < 0 ? 1 : -1));
    });
  }

  function closeLightbox() {
    if (!_el) return;
    var contentEl = _el.closest('.os9-browser-content') || _el;
    var lb = contentEl.querySelector('#sqv-lb');
    if (lb) lb.remove();
    _lightboxOpen = false;
  }

  /* ═══════════════════════════════════════════════════════════
     RENDER RESULT CARD
  ═══════════════════════════════════════════════════════════ */
  function renderCard(r) {
    var cat    = CATS[r.category] || { label: r.category, color: '#666', badge: '??' };
    var tags   = (r.tags || []).map(function(t) {
      return '<span class="sqv-tag" style="border-color:' + cat.color + ';color:' + cat.color + '">' + esc(t.trim()) + '</span>';
    }).join('');
    var meta   = [r.client, r.year].filter(Boolean).join(' \u00b7 ');
    var hasThumb = r.thumb && r.thumb.length > 0;
    var hasIcon  = r.icon  && r.icon.length  > 0;
    var imgCount = Array.isArray(r.images) ? r.images.filter(Boolean).length : 0;

    return '<div class="sqv-card" data-sqv-result>' +

      /* icon */
      '<div class="sqv-icon' + (hasIcon ? '' : ' sqv-icon--empty') + '">' +
        (hasIcon ? '<img src="' + esc(r.icon) + '" alt="" draggable="false" oncontextmenu="return false;">' : '') +
      '</div>' +

      /* category badge */
      '<span class="sqv-badge" style="background:' + cat.color + '">' + esc(cat.badge) + '</span>' +

      /* body */
      '<div class="sqv-body">' +
        '<span class="sqv-title">' + esc(r.title) + '</span>' +
        (meta ? '<div class="sqv-meta">' + esc(meta) + (imgCount ? ' &nbsp;\u00b7&nbsp; \uD83D\uDDBC\uFE0F ' + imgCount + ' image' + (imgCount !== 1 ? 's' : '') : '') + '</div>' : '') +
        '<span class="sqv-url">' + esc(r.domain || '') + '</span>' +
        '<div class="sqv-desc">' + (function() {
          var d = r.desc || '';
          var LIMIT = 220;
          if (d.length <= LIMIT) return esc(d);
          return esc(d.slice(0, LIMIT)) + '\u2026 <span class="sqv-read-more">read more</span>';
        })() + '</div>' +
        '<div class="sqv-tags">' + tags + '</div>' +
      '</div>' +

      /* thumbnail */
      '<div class="sqv-thumb' + (hasThumb ? '' : ' sqv-thumb--empty') + '">' +
        (hasThumb ? '<img src="' + esc(r.thumb) + '" alt="" draggable="false" oncontextmenu="return false;">' : '') +
      '</div>' +

    '</div>';
  }

  /* ═══════════════════════════════════════════════════════════
     REDRAW RESULTS
  ═══════════════════════════════════════════════════════════ */
  function redraw() {
    if (!_el) return;

    var results = filterResults(_query, _activeCategory);

    /* Specialty search links — highlight the active category */
    _el.querySelectorAll('.sqv-slink').forEach(function(t) {
      t.classList.toggle('sqv-slink--active', t.dataset.cat === _activeCategory);
    });

    /* Count */
    var countEl = _el.querySelector('#sqv-count');
    if (countEl) {
      var qLabel = _query ? ' for <strong>"' + esc(_query) + '"</strong>' : '';
      countEl.innerHTML =
        '<span>Found <strong>' + results.length + '</strong> result' + (results.length !== 1 ? 's' : '') + qLabel + '</span>' +
        '<span style="font-size:10px;color:#999;">SquichaVista\u2122 &mdash; Est. 1999</span>';
    }

    /* Results */
    var listEl  = _el.querySelector('#sqv-list');
    var emptyEl = _el.querySelector('#sqv-empty');
    if (!listEl) return;

    if (results.length === 0) {
      listEl.innerHTML = '';
      if (emptyEl) {
        emptyEl.style.display = 'block';
        emptyEl.innerHTML = 'No results for <strong>"' + esc(_query || 'your search') + '"</strong>. ' +
          '<a href="#" id="sqv-clear">Show all</a>';
        var cl = emptyEl.querySelector('#sqv-clear');
        if (cl) cl.addEventListener('click', function(e) { e.preventDefault(); doSearch(''); });
      }
    } else {
      if (emptyEl) emptyEl.style.display = 'none';
      listEl.innerHTML = results.map(renderCard).join('');

      /* Wire card clicks — the whole card opens the result */
      listEl.querySelectorAll('.sqv-card').forEach(function(card, i) {
        card.addEventListener('click', function() { openResult(results[i]); });

        /* Warm the first couple of images behind a result the moment the
           cursor arrives on its card. The row already shows a 60x45 thumb; the
           lightbox needs the full-size version, and pointing at a card is a
           good predictor of opening it. Only the first two — the rest are
           warmed on open, when the visitor has actually committed. */
        function warmCard() {
          var w = window.OS9Windows && window.OS9Windows.warmImages;
          var r = results[i];
          if (w && r && Array.isArray(r.images)) w(r.images.filter(Boolean).slice(0, 2));
        }
        card.addEventListener('mouseenter', warmCard, { passive: true });
        card.addEventListener('touchstart', warmCard, { passive: true });
      });
    }

    /* Sync input */
    var inp = _el.querySelector('#sqv-q');
    if (inp && inp !== document.activeElement) inp.value = _query;
  }

  function doSearch(q, cat) {
    _query = (q || '').trim();
    if (cat !== undefined) _activeCategory = cat;
    closeLightbox();
    redraw();
  }

  /* ═══════════════════════════════════════════════════════════
     BUILD PAGE HTML
  ═══════════════════════════════════════════════════════════ */
  function buildHTML() {
    var allCats = [{ key: 'all', label: 'All Results' }].concat(
      Object.keys(CATS).map(function(k) { return { key: k, label: CATS[k].label }; })
    );
    // Dash is appended INSIDE each nowrap span so it can never orphan at line-start.
    // A plain space between spans is the only allowed break point.
    var specLinksHtml = allCats.map(function(c, i) {
      var isLast = i === allCats.length - 1;
      var active = c.key === 'all' ? ' sqv-slink--active' : '';
      return '<span class="sqv-slink' + active + '" data-cat="' + c.key + '">' +
               c.label + (isLast ? '' : ' -') +
             '</span>';
    }).join(' ');

    return '<div id="sqv">' +

      '<div id="sqv-header">' +
        '<img src="https://cdn.shopify.com/s/files/1/0777/2844/8754/files/squichavista.png?v=1779037172" alt="SquichaVista" draggable="false" oncontextmenu="return false;">' +
      '</div>' +

      '<div id="sqv-search-zone">' +
        '<div id="sqv-search-row">' +
          '<input id="sqv-q" type="text" placeholder="Search the web..." autocomplete="off" spellcheck="false">' +
          '<button id="sqv-go">Search</button>' +
        '</div>' +
      '</div>' +

      '<div id="sqv-specialty">' +
        '<div id="sqv-spec-label">Specialty<br>Searches</div>' +
        '<div id="sqv-spec-links">' + specLinksHtml + '</div>' +
      '</div>' +
      '<div id="sqv-count"></div>' +

      '<div id="sqv-sponsor">' +
        '<strong>FEATURED:</strong>' +
        '<span>Hire Squiche Design Labs \u2014 <a href="https://squiche.com/pages/contact" target="_blank">squiche.com/contact</a></span>' +
      '</div>' +

      '<div id="sqv-list"></div>' +
      '<div id="sqv-empty"></div>' +

      '<div id="sqv-footer">' +
        'SquichaVista\u2122 &mdash; &copy; 1999 Squiche Design Labs, Philadelphia PA &mdash; ' +
        '<a href="https://squiche.com" target="_blank">squiche.com</a>' +
      '</div>' +

    '</div>';
  }

  /* ═══════════════════════════════════════════════════════════
     WIRE
  ═══════════════════════════════════════════════════════════ */
  function wire() {
    if (!_el) return;

    var inp = _el.querySelector('#sqv-q');
    var btn = _el.querySelector('#sqv-go');

    if (inp) inp.addEventListener('keydown', function(e) { if (e.key === 'Enter') doSearch(inp.value, _activeCategory); });
    if (btn) btn.addEventListener('click',   function()  { doSearch(inp ? inp.value : '', _activeCategory); });

    _el.querySelectorAll('.sqv-slink').forEach(function(link) {
      link.addEventListener('click', function() { doSearch(_query, link.dataset.cat); });
    });

    /* Block context menu globally on the page */
    _el.addEventListener('contextmenu', function(e) { e.preventDefault(); });
  }

  /* ═══════════════════════════════════════════════════════════
     MODULE API
  ═══════════════════════════════════════════════════════════ */
  window.OS9BrowserPages = window.OS9BrowserPages || {};
  window.OS9BrowserPages['altavista'] = {
    label: 'SquichaVista',
    icon:  '\uD83D\uDD0D',
    url:   'www.squichavista.com',

    mount: function(containerEl) {
      injectCSS();
      _el = containerEl;
      _el.innerHTML = buildHTML();
      _query = '';
      _activeCategory = 'all';
      wire();
      redraw();
    },

    search: function(query) {
      if (!_el) return;
      _query = (query || '').trim();
      _activeCategory = 'all';
      closeLightbox();
      var inp = _el.querySelector('#sqv-q');
      if (inp) inp.value = _query;
      redraw();
      var list = _el.querySelector('#sqv-list');
      if (list) list.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },

    reload: function() {
      if (!_el) return;
      closeLightbox();
      redraw();
    }
  };

})();